import { faTrashAlt } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { type CellContext } from '@tanstack/react-table';
import { useIntl } from 'react-intl';

import { EnevelopeRotate } from 'src/components/icons';
import { userManagementMessages } from 'src/features/userManagement/utils';
import { Button } from 'src/registry/ui/Button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';
import { generalMessages } from 'src/utils/messages';

import type { Invitation } from 'src/features/userManagement/types';

interface CellUserManagementActionsProps<TData, TValue> extends CellContext<TData, TValue> {
    resendCallback: (invitation: TData) => void;
    deleteCallback: (invitation: TData) => void;
}
function CellUserManagementActions({
    resendCallback,
    deleteCallback,
    row,
}: CellUserManagementActionsProps<Invitation, unknown>) {
    const expired = new Date(row.original.expiration_date) < new Date();
    const { formatMessage } = useIntl();

    return (
        <div className="ml-auto flex gap-4">
            {expired && (
                <TooltipProvider>
                    <Tooltip>
                        <TooltipTrigger asChild>
                            <Button onClick={() => resendCallback(row.original)} size="icon" variant="link">
                                <EnevelopeRotate className="size-5" />
                            </Button>
                        </TooltipTrigger>
                        <TooltipContent>
                            {`${formatMessage(generalMessages.resend)} ${formatMessage(userManagementMessages.invitation).toLocaleLowerCase()}`}
                        </TooltipContent>
                    </Tooltip>
                </TooltipProvider>
            )}

            <TooltipProvider>
                <Tooltip>
                    <TooltipTrigger asChild>
                        <Button onClick={() => deleteCallback(row.original)} size="icon" variant="link">
                            <FontAwesomeIcon icon={faTrashAlt} />
                        </Button>
                    </TooltipTrigger>
                    <TooltipContent>
                        {`${formatMessage(generalMessages.delete)} ${formatMessage(userManagementMessages.invitation).toLocaleLowerCase()}`}
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </div>
    );
}

export { CellUserManagementActions };
